/* eslint-disable @typescript-eslint/no-explicit-any */
import { ZendeskAPI } from 'react-zendesk'
import create from 'zustand'
import { UseChatLayerStore } from '.'
import { checkChatlayerAvailability } from './service'

export const useChatLayerStore = create<UseChatLayerStore>((set, get) => ({
  chatLayerInstance: null,

  setChatLayerInstance: (instance: any) => {
    set({
      chatLayerInstance: instance,
    })
  },

  counterSession: 0,

  setCounterSession: (counter: number) => {
    set({
      counterSession: counter,
    })
  },

  openZendesk: () => {
    ZendeskAPI('webWidget', 'show')
    ZendeskAPI('webWidget', 'open')
  },

  openChatLayer: async () => {
    try {
      const { status } = await checkChatlayerAvailability()

      if (status?.indicator !== 'none') {
        get().openZendesk()
        return
      }

      get().chatLayerInstance?.open()
    } catch (err) {
      get().openZendesk()
    }
  },
}))
